module.exports = __webpack_public_path__ + "static/media/3.aedf95fe.JPG";